<template>
  <div style="width: 94vw">
    <el-container style="padding: 25px 25px">
      <div class="bbb1">

        <el-header style="display: flex;height: 40px;">
          <span class="style-title">项目名称:</span>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini" @change="changeGame()"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>

          <span class="style-title">日期:</span>

          <el-date-picker
              v-model="value2"
              type="daterange"
              align="right"
              unlink-panels
              style="margin-left: 5px;margin-top: 9px;height:28px;width: 280px;align-items: center;display: flex"
              size="mini"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions3">
          </el-date-picker>
<!--          <el-checkbox-group-->
<!--              class="style-title"-->
<!--              v-model="checkedCities"-->
<!--              :min="1"-->
<!--              :max="3">-->
<!--            <el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>-->
<!--          </el-checkbox-group>-->

          <el-select v-show="optionsPerson.length>1" v-model="person" placeholder="人员选择" size="mini"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsPerson"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="search(true)" icon="el-icon-refresh">
            刷新
          </el-button>

        </el-header>


        <el-table
            ref="tableData1"
            :data="tableData5.filter(data => !person || data.c_author.toLowerCase().includes(person.toLowerCase()))"
            max-height="80vh"
            height="79vh"
            border
            style="margin-top: 11px"
            :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335'}"
            size="mini"
            :default-sort="{prop: 'uploadDate', order: 'descending'}"
            v-loading="loading"
            highlight-current-row

        >



          <el-table-column
              prop="c_date"
              label="日期"
              sortable
              min-width="130"

          >


          </el-table-column>

          <el-table-column
              prop="c_name"
              label="游戏名称"
              min-width="160"

          >

          </el-table-column>
          <el-table-column
              prop="c_author"
              label="投放人员"
              min-width="150"

          >

          </el-table-column>

          <el-table-column
              prop="c_amount"
              label="账面消耗（元）"
              min-width="180"
              sortable
              :formatter="value_format"

          >

          </el-table-column>



          <el-table-column
              prop="gameName"

              :label="'预估'+valueDay+'日利润（元）'"
              min-width="180"
          >

            <template slot-scope="{row}">

              <span style="color: #d65055" v-if=" row.value1- (row.c_amount / 100)>0">
                {{ row.value1===0?0:row.value1 - (row.c_amount / 100) |dataFilters2 }}</span>
              <!--                                                     预估倍率     -->
              <span style="color: #5daf34" v-else>
                {{
                  row.value1===0?0:  row.value1 - (row.c_amount / 100) |dataFilters2
                }}</span>
            </template>
          </el-table-column>


          <el-table-column
              prop="gameName"
              label="首日ROI"
              min-width="180"
          >

            <template slot-scope="{row}">

              <span style=" font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;">
                {{ ((row.value3 ) / row.c_amount * 100).toFixed(2) }}</span>

            </template>
          </el-table-column>

          <el-table-column
              prop="gameName"
              :label="'预估'+valueDay+'日ROI'"
              min-width="180"

          >
            <template slot-scope="{row}">

              <span style=" font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;">{{ (row.value1/row.c_amount*100).toFixed(2) }}</span>

            </template>
          </el-table-column>

          <el-table-column
              prop="gameName"
              :label="'预估'+valueDay+'日倍率'"
              min-width="180"

          >
            <template slot-scope="{row}">

              <span style=" font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;">{{ parseFloat(row.value1/row.value3).toFixed(2) }}</span>

            </template>
          </el-table-column>
          <el-table-column
              prop="gameName"
              label="备注"
              min-width="180"

          >
            <template slot-scope="{row}">


              <span v-if="row.ad_roi60===0||row.isSummary">
                    <span v-if="!row.isSummary">
              <span style=" font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;" v-if="row.change">

                <el-tag type="success">通过同品类预估</el-tag></span>

              <span style=" font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;" v-else>
                <span v-if="row.roi60!=0">
                   <el-tag >本游戏完成数据</el-tag>
                </span>
                <span v-else> <el-tag type="danger" >无完整预估数据</el-tag></span>

               </span>
                    </span>
                </span>
              <span v-else>


              <span v-if="row.ad_roi60" style=" font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;" ><el-tag type="warning">抖音后台实际数据</el-tag></span>
                <span v-else style=" font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;"><el-tag type="info">当天未出数据</el-tag></span>
              </span>

            </template>
          </el-table-column>

        </el-table>
        <el-pagination
            layout="total"
            :total="tableData5.length">
        </el-pagination>
      </div>


    </el-container>

  </div>
</template>
<script>
const cityOptions = ['游戏名', '日期'];
const cityOptions2 = ['ROI', '倍率'];
const  cityOptions3 = ['游戏名', '日期','品类'];
export default {
  name: "ProjectBroad",

  data() {

    return {
      showChart: false,
      selectedDays: [3, 7],

      roiDays: [3, 7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150],
      tableData5: [],
      yType: "2",
      dialogFormVisible: false,
      checkedCities: ['游戏名', '日期'],

      checkedCities2: ['ROI', '倍率'],
      activeName: 'first',
      cities: cityOptions,
      checkedYugu: ['游戏名','日期'],
      citiesYugu: cityOptions3,
      cities2: cityOptions2,
      isSort: true,
      list: [],
      value1: [],
      currentPage: 1,
      valueScene: '',
      fl: false,
      tableDataY4: [],
      loading: false,
      registerDate: "",
      type: 'pv',
      valueUser: "",
      avgEcpm: 0,
      value5: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      pickerOptions3: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      pickerOptions2: {
        disabledDate(date) {
          return date.getTime() >= Date.now() - 8.64e7;  //只能选择今天及今天之后的日期，如果没有后面的-8.64e7就是今天也不能选
        }
      },
      gameType:'',
      tableDataType:[],
      tableData: [],//营收
      tableData2: [],
      optionsGame: [],
      optionsPerson: [],
      optionsDay: ['按最新', 3, 7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150],
      valueDay: 60,
      valuePerson: "",
      valueGame: "",
      value: 0,
      value2: '',
      value3: 7,
      height: 800,
      arr1: [],
      arr2: [],
      valueGame2: '',
      items: ["7", "15", "30", "45", "60", "75", "90", "105", "120", "135", "150"],
      isSearch: true,
      person:'',
      form: {
        allDivisionScale: 0,
        divisionScale: 0.1,
        type: '流量主比例',
        date: [],
        checked: true
      },
      formLabelWidth: '140px',


    }


  },computed:{
    uniqueGameTypes() {
      // 从 tableData 中提取唯一的 gameType 值
      const gameTypes = this.tableDataType
          .map(item => item.gameType)
          .filter(type => type !== undefined && type !== null && type !== '');

      // 使用 Set 去重
      return [...new Set(gameTypes)];
    }

  }, watch: {

    colOptions(valArr) {
      // alert("sss");
      this.$nextTick(() => {
        this.$refs.tableDataRef.doLayout();
      });
    }
  }, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }, dataFilters2(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return "-"

      } else {

        return value.toFixed(2)

      }
    },
    dataFilters3(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')


      }
    }, dataFilters4(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {

        return value.toFixed(2) + '%'
      }

    }
  }, methods: {
    todayRange() {
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const today = `${year}-${month}-${day}`
      return [today, today]
    },
    getSearchCache() {
      try {
        return JSON.parse(localStorage.getItem("ToufangSelf") || "{}") || {}
      } catch (e) {
        return {}
      }
    },
    normalizeDateRange(value) {
      if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
        return value
      }
      if (typeof value === 'string' && value.length >= 10) {
        const day = value.substring(0, 10)
        return [day, day]
      }
      return this.todayRange()
    },
    restoreSearchCache() {
      const cache = this.getSearchCache()
      if (Object.prototype.hasOwnProperty.call(cache, 'name')) {
        this.valueGame = cache.name || ''
      }
      this.value2 = this.normalizeDateRange(cache.date)
      if (cache.a) {
        this.activeName = cache.a
      }
      if (Object.prototype.hasOwnProperty.call(cache, 'date2')) {
        this.value5 = cache.date2
      }
    },
changeFiter(){

  if(this.person!==''){


    // this.tableData5 = this.tableData5.filter(item => item.c_author === this.person)
  }


},

    getCellClass({column}) {

      console.log(column)
      if (column.prop === 'cAmount') {
        return 'table-number2'
      }
      return ''
    },
    get() {

      this.$axios
          .get('/toufang/data/getDefault?type=' + this.form.type, {})

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.form.allDivisionScale = successResponse.data.data

            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })
    },
    change() {


      this.$axios
          .post('/toufang/data/updateDefault', this.form)

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.$message({
                message: '更新' + this.form.type + '默认值成功!',
                type: 'success'
              });
            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })


    },
    formDate(date) {
      // 将Excel日期转换为JavaScript日期
      const jsDate = new Date((date - 25569) * 86400 * 1000);
      // 将JavaScript日期转换为指定格式：yyyy-MM-dd
      const year = jsDate.getFullYear();
      const month = String(jsDate.getMonth() + 1).padStart(2, '0');
      const day = String(jsDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
   ,changeGame(){

      if(this.valueGame!==""){

        this.checkedYugu=['游戏名','日期']

      }


    },
    indexMethod(index) {

      return index / 6 + 1;

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    }, objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。(可能还有边距/边框等值，需要根据实际情况加上)
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },

    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },



    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    },
    value_format(row, column, value) {
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return '-'

      } else {
        value = Math.round(value / 100)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return value.toFixed(2)

      } else {

        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format4(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return '-'

      } else {

        return value
      }
    }, findGame() {

      this.$axios
          .get('/toufang/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    }, handleClick(tab, event) {

      console.log(tab.name)

    },
    // 添加合计行的方法
    addSummaryRow() {
      if (!this.tableData5 || this.tableData5.length === 0) return;

      // 计算合计值
      const summary = {
        c_date: '合计',
        c_name: '-',
        c_author: '-',
        c_amount: 0,
        value1: 0,
        value3: 0,
        isSummary: true // 标记为合计行
      };

      this.tableData5.forEach(item => {
        summary.c_amount += item.c_amount || 0;
        summary.value1 += item.value1 || 0;
        summary.value3 += item.value3 || 0;
      });

      return summary;
    },
    search(flag) {

      if (this.checkedCities.length < 2) {

        this.items = []

      } else {

        this.items = ["7", "15", "30", "45", "60", "75", "90", "105", "120", "135", "150"]
      }

      if (flag) {

        console.log("手动选条件")

        localStorage.setItem("ToufangSelf", JSON.stringify({
          name: this.valueGame,
          date: this.value2,
          a: this.activeName,
          checkedCities: this.checkedCities,
          date2: this.value5
        }))
      } else {
        console.log("获取选条件")
        this.restoreSearchCache()

      }


      this.maxHeight = window.innerHeight - 250;

      if(this.value2.length>1){


        this.loading = true
        this.$axios
            .post('/toufang/data/findAllByPerson', {
              start: this.value2[0],
              cname: this.valueGame == null ? '' : this.valueGame,
              currentPage: this.currentPage4 == null ? 1 : this.currentPage4,
              end: this.value2[1],
              param: "",
              author: this.valuePerson == null ? '' : this.valuePerson,
              day: this.valueDay
            })
            .then(successResponse => {

              this.tableData5 = successResponse.data.data

              this.optionsPerson = [...new Set(this.tableData5.map(item => item.c_author))];


              this.tableData5.forEach(function (e) {

                e.cAmount = parseFloat(e[1])


                //预估60日收入 e[27]60日倍率 e[23]占比比例 e[25]ROI e[26]消耗 e[27]预估收入 e[28]首日ROI e[29]首日占比比例 e[30]占比比例 e[31]占比比例 e[32]占比比例 e[33]占比比例 e[34]占比比例 e[35]占比比例 e[36]占比比例 e[37]占比比例 e[38]占比比例
                e.value1 = (e.roi60 * (e.ad_roi1/100 * e.c_amount/100 * (e.percentage==null?100:e.percentage) / 100))

                //首日实际收入   e[28]首日ROI *e[1]消耗*e[30]占比比例
                e.value3 = e.ad_roi1/100 * e.c_amount/100  * (e.diff_0_percentage==null?100:e.diff_0_percentage) / 100


              })
              console.log(this.tableData5)

              const summaryRow = this.addSummaryRow();
              if (summaryRow) {
                this.tableData5.unshift(summaryRow);
              }

              //只有日期
              if (this.checkedCities.length < 2 && this.checkedCities.indexOf('日期') > -1) {

                const grouped = this.tableData5.reduce((acc, item) => {
                  const key = item['c_date'];
                  if (!acc[key]) {
                    acc[key] = {
                      c_date: key,
                      value1: 0,
                      value3: 0,
                      cAmount: 0,
                    };
                  }
                  acc[key].value1 += item.value1;

                  acc[key].value3 += item.value3;
                  acc[key].cAmount += item.cAmount
                  acc[key]["c_author"] = this.valuePerson === '' ? '-' : this.valuePerson

                  return acc;
                }, {});

                console.log(Object.values(grouped))

                this.tableData5 = Object.values(grouped)

                //只有游戏
              } else if (this.checkedCities.length < 2 && this.checkedCities.indexOf('游戏名') > -1) {


                const grouped = this.tableData5.reduce((acc, item) => {
                  const key = item["c_name"];
                  if (!acc[key]) {
                    acc[key] = {
                      c_name: key,
                      value1: 0,
                      value3: 0,
                      cAmount: 0,
                      8: 0
                    };
                  }
                  acc[key].value1 += item.value1;

                  acc[key].value3 += item.value3;
                  acc[key].cAmount += item.cAmount
                  acc[key]["c_author"] = this.valuePerson === '' ? '-' : this.valuePerson

                  return acc;
                }, {});

                console.log(Object.values(grouped))

                this.tableData5 = Object.values(grouped)

              }

              this.optionsGame  =successResponse.data.namelist

              this.loading = false
            })

      }
    },

  }
  , updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  },
  mounted: function () {
    this.height = window.innerHeight;
    this.findGame()
    this.restoreSearchCache()
    this.search(false)

  }


}
</script>
<style>

.yugu {
  color: #d65055;
  font-weight: 540;

  //font-family: Georgia, 'Times New Roman', serif;
}

.yugu2 {
  color: #3a8ee6;
  //font-family: Georgia, 'Times New Roman', serif;
  font-weight: 500;
}
</style>

<style type="text/css">

*::-webkit-scrollbar {
  width: 5px;
  height: 12px;
  background-color: transparent;
}

.table-number {
  //font-family: 'Consolas', monospace;
  font-size: 12px;
  color: #4b4b4f;
  text-align: right;
}

.table-header {
  font-family: '思源黑体', sans-serif;
  font-size: 14px;
}
.updated-marker-icon {
  color: #e39f0b;
  font-size: 14px;
  margin-left: 5px;
  vertical-align: middle;
}
.bbb1 {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 96%;
  min-height: 85vh;
  display: flex;
  flex-direction: column;

}

.bbb1::after {
  content: "";
  display: table;
  clear: both;
}

</style>


<style scoped>
.red{

  color: #d65055;

}

.green{

  color: #5daf34;
}

/* Vue2 语法 */
.chart-container {
  padding: 20px;
  width: 97%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.el-select2 {
  margin-bottom: 20px;
  width: 100%;
}

/deep/ .el-tabs__item {
  font-size: 15px; /* 字体大小 */
  font-family: '思源黑体', sans-serif; /* 字体类型 */
  color: #565454; /* 默认颜色 */
  font-weight: bold; /* 字重 */
}

/* Vue2 兼容写法 */
::v-deep .el-tabs__nav {
  font-weight: bold;
}

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.96);

}

/deep/ .el-range-input {
  background-color: rgba(248, 245, 245, 0.94);

}
</style>
